import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements AfterViewInit {
  @ViewChild('tabGroup')
  public tabGroup: MatTabGroup;
  public isSalesCompany: boolean;
  public isSuperUser: boolean;

  get queryParams(): Observable<string> {
    return this.route.queryParamMap.pipe(map((param) => param.get('tab')));
  }

  constructor(private route: ActivatedRoute, private authService: AuthService) { }

  ngAfterViewInit(): void {
    this.isSalesCompany = this.authService.IsSalesCompany();
    this.isSuperUser = this.authService.IsSuperUser();
    this.queryParams.subscribe((param) => {
      if (param !== null) {
        if (param === 'template-management') {
          this.tabGroup.selectedIndex = 1;
        }
      }
    });
  }
}
